export default __webpack_public_path__ + "static/media/Ppt_icon.88b6467e.svg";